export const getOrganizationIdFromWorkspaceKey = (selectedWorkspaceKey) => {
  if (typeof selectedWorkspaceKey !== "string") return null;
  if (!selectedWorkspaceKey.startsWith("org:")) return null;

  const organizationId = selectedWorkspaceKey.slice(4).trim();
  return organizationId || null;
};

export const buildWorkspaceRequestHeaders = (selectedWorkspaceKey) => {
  const organizationId = getOrganizationIdFromWorkspaceKey(selectedWorkspaceKey);
  return organizationId ? { "x-organization-id": organizationId } : {};
};

export const buildWorkspaceRequestHeadersFromState = (state) => {
  return buildWorkspaceRequestHeaders(state?.workspace?.selectedWorkspaceKey);
};
// A project, draft or scenario opened from the wrong workspace: the server answers 409
// WORKSPACE_MISMATCH with the workspace it belongs to — only to someone who can open it there.
export const workspaceMismatchOf = (error) => {
  const response = error?.response;
  if (response?.status !== 409 || response?.data?.code !== "WORKSPACE_MISMATCH") return null;
  return response.data.workspace?.key ? response.data.workspace : null;
};
